import { ApiGetRequest, ApiPostRequest, ApiPutRequest } from '../../api';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Update Container In',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/adm/conf',
      },
      {
        text: 'UpdateContIn',
        href: '/adm/conf/update-container-in',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_update_cont_in',
    sortDesc: true,
    fields: [
      {
        key: 'date_input',
        label: 'Date',
      },
      {
        key: 'doc_no',
        label: 'Document No',
      },
      {
        key: 'container_no',
        label: 'Container',
      },
      {
        key: 'date_update',
        label: 'Date Update',
      },
      {
        key: 'type_update',
        label: 'Type',
      },
      {
        key: 'status_update',
        label: 'Status',
      },
      {
        key: 'error_info',
        label: 'Error Info',
      },
    ],
    type_update: [
      {
        label: 'Pay In',
        value: 'pay_in',
      },
      {
        label: 'Survey In',
        value: 'survey_in',
      },
      {
        label: 'Crani In',
        value: 'crani_in',
      },
      {
        label: 'Date Out Port',
        value: 'date_out_port',
      },
      {
        label: 'EOR',
        value: 'eor',
      },
      {
        label: 'Work Order',
        value: 'work_order',
      },
      {
        label: 'Quality Control',
        value: 'quality_control',
      },
      {
        label: 'Approval',
        value: 'approval',
      },
      {
        label: 'Begin Repair',
        value: 'begin_repair',
      },
      {
        label: 'Complete Repair',
        value: 'complete_repair',
      },
      {
        label: 'Pay Out',
        value: 'pay_out',
      },
      {
        label: 'Crani & Survey Out',
        value: 'crani_survey',
      },
      {
        label: 'Payment Seal',
        value: 'payment_seal',
      },
    ],
    detail: false,
    form: {
      id_account: '',
      acc_code: '',
      acc_name: '',
    },
    import_form: [],
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  import_form(state) {
    return state.data.import_form;
  },
};

export const mutations = {
  changeUpdateContIn(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchUpdateContIn(context, params = null) {
    let result = await ApiGetRequest(`conf/update-cont-in`, params);
    return !result.error ? result.data.object : [];
  },

  async getListUpdateContIn({ commit, state }) {
    commit('changeUpdateContIn', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`conf/update-cont-in`, params);
    commit('changeUpdateContIn', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async getDetailUpdateContIn({ commit, state }, payload = null) {
    commit('changeUpdateContIn', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`conf/update-cont-in/${payload.id}`);
    commit('changeUpdateContIn', {
      loading: false,
      form: {
        ...data.form,
        ...result.data.object,
      },
    });

    return result.error ? false : true;
  },

  async importData({ commit, dispatch, state }) {
    commit('changeUpdateContIn', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(`conf/update-cont-in`, data.import_form);

    commit('changeUpdateContIn', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateUpdateContIn({ commit, state, dispatch }, payload = null) {
    commit('changeUpdateContIn', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `conf/update-cont-in/${payload.id}`,
      state.data.form
    );

    commit('changeUpdateContIn', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },
};
